import { appSettings } from '@/settings/app-settings';

/* eslint-disable @next/next/no-img-element */
const SignInHeader = () => {
  // const triggeringFunction = () => {
  //   const handler = (event: MessageEvent) => {
  //     console.log('message from event origin', event.origin);
  //     console.log('Host', appSettings.api.CLIENT_APP_URL);

  //     if (event.origin !== appSettings.api.CLIENT_APP_URL) {
  //       console.log('other origin ');
  //     }
  //     console.log('message from event', event.data);
  //   };

  //   window.addEventListener('message', handler);
  //   const iframe = document.createElement('iframe');
  //   iframe.style.display = 'none';
  //   iframe.src = `${appSettings.api.CLIENT_APP_URL}/ssoLoadingPage`;
  //   document.body.appendChild(iframe);
  //   console.log('triggering');
  //   console.log('appSettings.api.CLIENT_APP_URL', appSettings.api.CLIENT_APP_URL);
  // };

  const triggeringFunction = () => {
    const handler = (event: MessageEvent) => {
      const expectedOrigin = appSettings.api.CLIENT_APP_URL; // trusted main domain

      console.log('📩 Received message from', event.origin);
      if (event.origin !== expectedOrigin) {
        console.warn('🚫 Ignoring message from untrusted origin:', event.origin);
        return;
      }

      const { type, jwt, refreshToken, profileData } = event.data;

      if (type === 'SSO_TOKEN') {
        console.log('✅ SSO Token received:', jwt);

        // Save to localStorage, cookies, or dispatch to context/store
        localStorage.setItem('jwt', jwt);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('profileData', JSON.stringify(profileData));

        // Optional: Navigate
        // window.location.href = '/dashboard';
      }
    };

    window.addEventListener('message', handler, { once: true }); // Only handle one message

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `${appSettings.api.CLIENT_APP_URL}/ssoLoadingPage`; // URL of your SSO token page
    document.body.appendChild(iframe);
  };

  return (
    <div>
      <div className="relative mt-6">
        <img
          src="/images/connect/connect-bg-1.png"
          alt="connectBg-1"
          className="absolute opacity-50 top-[-10px] right-[80px] md:right-[90px] w-[20px] h-[20px] dark:mix-blend-difference"
        />
        <img
          src="/images/connect/connect-bg-2.png"
          alt="connectBg-2"
          className="absolute opacity-50 top-[30px] right-[70px] md:right-[80px] w-[40px] h-[40px] dark:mix-blend-difference"
        />
        <img
          src="/images/connect/connect-bg-2.png"
          alt="connectBg-2"
          className="absolute opacity-50 top-[-10px] left-[5px] md:left-[20px] w-[50px] h-[50px] dark:mix-blend-difference"
        />
        <img
          src="/images/connect/connect-bg-3.png"
          alt="connectBg-3"
          className="absolute opacity-50 top-[-10px] right-[-10px] md:right-[5px] w-[80px] h-[80px] dark:mix-blend-difference"
        />
        <div className="text-2xl flex justify-center font-bold">Your Digital Future</div>
        <div className="text-2xl flex justify-center font-bold">Starts Here</div>
      </div>
      <div className="flex justify-center text-xs md:text-sm mt-4 font-medium">
        Claim your profile to access your personal infrastructure
      </div>
      <div className="flex justify-center text-xs md:text-sm font-medium">
        and start creating and collaborating with your toolkit,
      </div>
      <div
        // onClick={() => {
        //   triggeringFunction();
        // }}
        role="button"
        tabIndex={0}
        onKeyDown={() => {}}
        className="flex justify-center text-xs md:text-sm mb-[18px] italic font-bold"
      >
        on your terms
      </div>
    </div>
  );
};

export default SignInHeader;
